import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
export const StyledHubspotDynamicFormIframeComponent = styled.div`
  max-width: ${`${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px`};
  margin: auto;
  display: flex;
  justify-content: center;

  .contact-sales-hubspot-form-component {
    max-width: 550px;
    width: ${({ formWidth })=>formWidth ? `${formWidth}` : "100%"};
  }
`;
